/* global Image */

import React, { PureComponent } from 'react'
export default class SquareGridThumb extends PureComponent {
    static defaultProps = {
      fallbackURL: '/img/gonation-nav-icon.png',
      maxTries: 3,
    }

    constructor(props) {
      super(props)

      this.img = new Image()
      this.reloadTries = 0

      this.state = {
        isLoading: true,
        imgURL: false,
      }
    }

    componentDidMount() {
      this.img.onload = () => {
        this.setState({ isLoading: false, imgURL: this.img.src })
      }

      this.img.onerror = () => {
        this.setState({ isLoading: false, imgURL: this.props.fallbackURL })


        if (this.reloadTries < this.props.maxTries) {
          setTimeout(() => {
            // console.log('try again')
            this.img.src = this.props.imgSrc
            this.reloadTries = this.reloadTries + 1
          }, 1000)
        }
      }

      this.img.src = this.props.imgSrc
    }

    render() {
      // if (this.state.isLoading) {
      //   return false
      // }

      const bgStyle = {
        backgroundImage: `url('${this.state.imgURL}')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }

      const wrapperClass = (this.state.isLoading) ? 'album-grid-thumb thumb-is-loading' : 'album-grid-thumb'

      return (
        <div className={this.props.className}>
          <div className={wrapperClass} style={bgStyle}>
            <img src="img/spaced-out.gif" alt="Grid Thumbnail" />
          </div>
        </div>
      )
    }
}




// WEBPACK FOOTER //
// ./src/views/Components/SquareGridThumb.js